var bigSlide = require('bigslide');
$('.menu-link').bigSlide({
    menu: '#slide-menu',
    side: 'left',
    easyClose: true,
    menuWidth: '20em',
    afterOpen: function(){
        $('body').css('overflow-xs', 'hidden');
        $('#slide-menu').css('opacity', 1);
    },
    afterClose: function(){
      $('#slide-menu').css('opacity', 0);
    }
});



// WEBPACK FOOTER //
// ./js/modules/_bigslide.js